import { render, staticRenderFns } from "./UserAuthentication.vue?vue&type=template&id=0dd6a33a&scoped=true&"
import script from "./UserAuthentication.vue?vue&type=script&lang=js&"
export * from "./UserAuthentication.vue?vue&type=script&lang=js&"
import style0 from "./UserAuthentication.vue?vue&type=style&index=0&id=0dd6a33a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6a33a",
  null
  
)

export default component.exports